const requireContext = require.context('./modules', false, /.*\.js$/)

const modules = requireContext.keys()
  .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file).default])
  .reduce((modules, [name, module]) => {
    return { ...modules, [name]: module }
  }, {})

export default modules
